import {
  CompanyOperationalStatus,
  DeliveryMode,
  InvoiceStatus,
  SetupPackageType,
  SubscriptionTerm,
} from '../../../../../services/exports/Constants';

export default {
  sections: {
    people: 'Personer',
    financial_metrics: 'Økonomiske nøgletal',
    onboarding_and_quality: 'Onboarding og kvalitet',
    subscriptions: 'Aktuelle abonnementer',
    payments: 'Betalinger',
    last_invoices: 'Seneste fakturaer',
  },
  fields: {
    google_profile: 'Google-profil',
    owner_name: 'Ejerens navn',
    owner_phone_number: 'Ejerens telefon',
    company_phone_number: 'Restaurantens telefon',
    address: 'Adresse',
    onboarding_manager: 'Onboarding-manager',
    sales_manager: 'Salgschef',
    last_30_days_sales: 'Omsætning de seneste 30 dage',
    lifetime_sales: 'Samlet omsætning i alt',
    monthly_sales_other_platforms: 'Salg via leveringsapps',
    last_payout: 'Seneste udbetaling',
    potential_tier: 'Potentialescore',
    current_tier: 'IST-score',
    signed_at: 'Lukningsdato',
    live_from: 'Go-live-dato',
    onboarding_quality_score: 'Go-live-kvalitetsscore',
    is_google_business_available: 'Google Business tilgængelig',
    is_smart_pricing_configured: 'Billigere priser end Lieferando, Wolt, Uber',
    is_flyers_package_sent: 'Reklameflyer sendt',
    is_menu_fully_configured: 'Alle menupunkter tilgængelige',
    has_offers_on_competitor_platforms:
      'Kører restauranten tilbud på Wolt, Uber, Lieferando (undtagen tilbud om gratis levering)?',
    is_instagram_story_shared: 'Instagram-story delt med ejeren',
    is_order_system_connected_to_website:
      'Foodamigos-website forbundet ELLER restaurantens egen knap til onlinebestilling tilføjet',
    delivery_mode: 'Chauffører',
    has_storefront: '{{provider}}-website',
    screening_date: 'Screeningsdato',
  },
  setup_fee: {
    title: 'Implementeringsgebyr',
    status: {
      [InvoiceStatus.Paid]: 'Betalt',
      [InvoiceStatus.Pending]: 'Afventer',
      [InvoiceStatus.Processing]: 'Behandles',
      [InvoiceStatus.Refunded]: 'Refunderet',
      [InvoiceStatus.PartiallyRefunded]: 'Delvist refunderet',
      [InvoiceStatus.Failed]: 'Mislykkedes',
    },
  },
  labels: {
    yes: 'Ja',
    no: 'Nej',
    month: 'Måned',
  },
  operational_status: {
    [CompanyOperationalStatus.Live]: 'Aktiv',
    [CompanyOperationalStatus.Paused]: 'Sat på pause',
    [CompanyOperationalStatus.Suspended]: 'Opsagt',
  },
  setup_packages: {
    [SetupPackageType.Default]: 'Standard',
    [SetupPackageType.Preferred]: 'Pro',
    [SetupPackageType.Custom]: 'Plus',
  },
  contract_terms: {
    [SubscriptionTerm.Monthly]: 'Månedlig',
    [SubscriptionTerm.Annual]: 'Årlig',
  },
  delivery_modes: {
    [DeliveryMode.Internal]: 'Egne chauffører',
    [DeliveryMode.External]: '{{provider}}-chauffører',
  },
  buttons: {
    view_details: 'Se detaljer',
    open: 'Åbn',
  },
  toasts: {
    failed_to_load_data: 'Data kunne ikke indlæses',
  },
};
